import { createAction, props } from "@ngrx/store";
import { CreateTeamTeachers } from "src/app/modules/orgadmin/components/team-teachers/team-teachers-output.model";
import { CreateTeamTeachersResponse } from "src/app/shared/interfaces/orgadmin/course-teachers";

export const coursePrefix = "[Create Team Teachers]";

const createTeamTeachersActions = {
  request: `${coursePrefix} Load`,
  requestSuccess: `${coursePrefix} Load success`,
  requestFail: `${coursePrefix} Load fail`,
};

export const createTeamTeachersSuccess = createAction(
  createTeamTeachersActions.request,
);

export const createTeamTeachersLoad = createAction(
  createTeamTeachersActions.requestSuccess,
  props<{
    organizationId: string;
    courseId: string;
    subId: string;
    payload: CreateTeamTeachers;
    notificationMessage?: string;
    packageId?: string;
    name?: string;
  }>(),
);

export const createTeamTeachersFail = createAction(
  createTeamTeachersActions.requestFail,
  props<{ error: CreateTeamTeachersResponse | null }>(),
);
